import React, { Fragment } from 'react'
import styled from 'styled-components'
import { H2 } from 'app/common/typography'
import { ButtonMedium } from 'app/assets/styles'
import { colors } from 'shared/assets/styles'
import { FormattedMessage } from 'react-intl'
import { Layout } from 'app/common/layout'
import { Bite } from 'app/common/bite'

const refreshPage = () => {
    window.location.reload(true)
}

const Error = () => (
    <Layout color="white">
        <Bite />
        <Wrapper>
            <TextContainer>
                <Fragment>
                    <FormattedMessage id={`error.network.section.title`}>
                        {(text: string) => <H2>{text}</H2>}
                    </FormattedMessage>
                </Fragment>
                <Button onClick={refreshPage}>
                    <FormattedMessage id="error.button.label">
                        {(text: string) => (
                            <ButtonMedium background={colors.yellow}>
                                {text}
                            </ButtonMedium>
                        )}
                    </FormattedMessage>
                </Button>
            </TextContainer>
        </Wrapper>
    </Layout>
)

const Wrapper = styled.div`
    background-color: ${colors.red2};
    text-align: center;
    padding-bottom: 75px;
    padding-top: 75px;
    ${H2} {
        color: white;
    }
    height: 100vh;
`

const TextContainer = styled.div`
    position: relative;
    top: 50%;
    transform: translateY(-80%);
    margin: auto 20px;
`

const Button = styled.div`
    margin-top: 20px;
`

export { Error }
